import { call, put, takeLatest } from "redux-saga/effects";

// import {
//   FETCH_LANGUAGES_REQUEST,
// } from "./actions";
import { FETCH_LANGUAGES_FAILURE, FETCH_LANGUAGES_REQUEST, FETCH_LANGUAGES_SUCCESS } from "../type";
import { base_url } from "../../components/config";

const LANGUAGES_API =
  `${base_url}ps_commoncontent/languages`;

function* fetchLanguagesSaga() {
  try {
    const response = yield call(fetch, LANGUAGES_API);

    if (!response.ok) {
      throw new Error("Failed to fetch languages");
    }

    const data = yield call([response, "json"]);

    if (!data.success) {
      throw new Error("Language API failed");
    }

    yield put({type: FETCH_LANGUAGES_SUCCESS,payload: data.languages,});
  } catch (error) {
    yield put({type: FETCH_LANGUAGES_FAILURE,payload: error.message,});
  }
}

export function* languageSaga() {
  yield takeLatest(
    FETCH_LANGUAGES_REQUEST,
    fetchLanguagesSaga
  );
}